module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-a1eea166!./packages/dof-switch/colmo.css
// module id = 524
// module chunks = 0 1